import { createSlice } from '@reduxjs/toolkit';

import { State, STATE } from '../types/state';

import setSettings from './setSettings';
import updateSettings from './updateSettings';
import setSettingsStatusLoading from './setSettingsStatusLoading';
import setUpdateSettingsStatusLoading from './setUpdateSettingsStatusLoading';
import setCanUseRestrictions from './setCanUseRestrictions';

const initialState: State = {
  settings: {},
  canUseRestrictions: false,
};

const slice = createSlice({
  name: STATE,
  initialState,
  reducers: {
    setSettings,
    updateSettings,
    setSettingsStatusLoading,
    setUpdateSettingsStatusLoading,
    setCanUseRestrictions,
  },
});

export default slice;
